import React, { Component } from 'react';
import Calendar from 'react-calendar';

class DatePicker extends Component {
    
    constructor(props){
        super(props);
        this.state = {
            date: new Date()
        }   
    }
    onChange = date => {
        this.setState({ date });
        this.props.input.onChange(date);
        this.props.onDateChange(date); 
       
    }

    render(){
         const {minDate, maxDate,minDetail} = this.props;
            return(
                <Calendar
                onChange={this.onChange}
                value={this.state.date}
                minDate={minDate}
                maxDate={maxDate}
                minDetail={minDetail}
                minDetail="year"
            />
        )
  
    }

}
export default DatePicker;